export default function Manifesto() {
  return (
    <section id="manifesto" className="manifesto">
      <div className="container">
        <div className="manifesto-grid">
          <blockquote className="reveal">
            <span>Most AI</span>{" "}<span className="em">platforms</span>{" "}
            <span className="strike">promise</span>{" "}<span>privacy.</span><br />
            We <span style={{ color: "var(--accent)" }}>guarantee</span> it.
          </blockquote>
          <div className="manifesto-attribution reveal d1">
            A line, drawn deliberately.<br />
            Not a feature.<br />
            <b>By design — not by policy.</b><br /><br />
            — QuantumX · Media Minds AI Group
          </div>
        </div>
      </div>
    </section>
  );
}
